'use client';

import React, { createContext, useContext, useState, ReactNode } from 'react';
import { FinancialPortal } from '@generated-gql/generated-types';
import { PlaidStep } from './plaid-modal-stepper';
import { useSearchParams } from 'next/navigation';
import { OAUTH_QUERY_PARAM } from '../constants';

export interface SetShowPlaidVisibilityParams {
  show: boolean;
  plaidStep?: PlaidStep;
  selectedPortal?: FinancialPortal;
}

interface PlaidModalVisibilityContextType {
  showPlaidVisibility: SetShowPlaidVisibilityParams;
  setShowPlaidVisibility: (params: SetShowPlaidVisibilityParams) => void;
  isOAuth: boolean;
}

const PlaidModalVisibilityContext = createContext<
  PlaidModalVisibilityContextType | undefined
>(undefined);

export const PlaidModalVisibilityProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const [showPlaidVisibility, setShowPlaidVisibility] =
    useState<SetShowPlaidVisibilityParams>({ show: false });
  const searchParams = useSearchParams();

  const isOAuth = searchParams.has(OAUTH_QUERY_PARAM);
  return (
    <PlaidModalVisibilityContext.Provider
      value={{
        showPlaidVisibility,
        setShowPlaidVisibility,
        isOAuth,
      }}
    >
      {children}
    </PlaidModalVisibilityContext.Provider>
  );
};

export const usePlaidModalVisibility = () => {
  const context = useContext(PlaidModalVisibilityContext);
  if (!context) {
    throw new Error(
      'usePlaidModalVisibility must be used within a PlaidModalVisibilityProvider',
    );
  }
  return context;
};
